"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockCounty = void 0;
const state_1 = require("./state");
function mockCounty(overrides = {}) {
    return {
        name: 'Ramsey',
        state: (0, state_1.mockState)(),
        ...overrides,
    };
}
exports.mockCounty = mockCounty;
